export default {
  send: 'Enviar',
  cancel: 'Cancelar',
  ok: 'Ok',
  save: 'Guardar',
  destroy: 'Eliminar',
  removal: 'Eliminación',
  add: 'Agregar',
  close: 'Cerrar',
  comeOut: 'Salir',
  warning: 'Advertencia',
  search: 'Buscar',
  settings: 'Configuración',
  invite: 'Invitar',
  back: 'Atrás',
  empty: 'Vacío',
  edit: 'Editar',
  show: 'Mostrar',
  confirm: 'Confirmar',
  continue: 'Continuar',
  total: 'Total',
  subtotal: 'Subtotal por ',
  nothingFound: 'No se encontró nada',
  noData: 'Sin datos',
  complete: 'Finalizar',
  report: 'Informe',
  move: 'Ir',
  time: 'Tiempo',
  cut: 'Cortar',
  update: 'Actualizar',
  error: 'Error',
  selectLang: 'Seleccione el idioma',
  select: 'Seleccionar',
  noAccess: 'No tiene acceso al recurso.',
  resourceNotAvailable: '404 - El recurso no existe.',
  youWantRemove: '¿Realmente desea eliminar ',
  enterSearch: 'Comience a escribir el nombre para buscar',
  saveInExcel: 'Guardar en Excel',
  downloadExcel: 'Descargar Excel',
  saveAndDownload: 'Guardar y descargar',
  yes: 'Sí',
  no: 'No',
  dialog: {
    fullscreen: 'Pantalla completa',
    exitFullscreen: 'Salir de pantalla completa',
    inFullscreen: 'A pantalla completa',
  },
  login: {
    entry: 'Inicio de sesión',
    loginOrEmail: 'Usuario o email',
    enterLoginOrEmail: 'Introduzca usuario o email',
    password: 'Contraseña',
    enterPassword: 'Introduzca la contraseña',
    resetPassword: 'Restablecer contraseña',
    enter: 'Entrar',
    userNotFound: 'Usuario no encontrado',
    sentLetter: 'Se ha enviado un mensaje a su email',
    incorrectLoginOrPassword: 'Usuario o contraseña incorrectos',
  },
  registry: {
    name: 'Nombre',
    enterName: 'Introduzca su nombre',
    login: 'Usuario',
    enterLogin: 'Introduzca su usuario',
    farmName: 'Nombre de la explotación',
    enterFarmName: 'Introduzca el nombre de la explotación',
    email: 'Email',
    enterEmail: 'Introduzca su email',
    innFarm: 'NIF de la explotación',
    enterInnFarm: 'Introduzca el NIF de la explotación',
    createPassword: 'Cree una contraseña',
    confirmPassword: 'Confirme la contraseña',
    code: 'Código',
    phone: 'Teléfono',
    enterPhone: 'Introduzca el teléfono',
  },
  personalAccount: {
    title: 'Cuenta personal',
    wantQuit: '¿Está seguro de que desea salir?',
    fullName: 'Nombre completo',
    changePassword: 'Cambiar contraseña',
  },
  changePassword: {
    repeatPassword: 'Repita la contraseña',
    enterSamePassword: 'Introduzca contraseñas iguales',
    newPassword: 'Nueva contraseña',
    changedPassword: 'Su contraseña ha sido cambiada. Vaya a la página de inicio de sesión.',
  },
  organizations: {
    title: 'Organizaciones',
    organization: 'Organización',
    currentOrganization: 'Organización actual',
    nameOrganization: 'Nombre de la organización',
    settingOrganization: 'Ajustes de la organización',
    typeOrganization: 'Tipo de organización',
    inn: 'NIF',
    changeOrganization: 'Cambiar organización',
    selectOrganization: 'Seleccionar organización',
    addOrganization: 'Agregar organización',
    newOrganization: 'Nueva organización',
    farm: 'Explotación',
  },
  fields: {
    title: 'Campos',
    field: 'Campo',
    myFields: 'Mis campos',
    listFields: 'Lista de campos',
    addField: 'Agregar campo',
    newField: 'Campo nuevo',
    deleteField: 'Eliminar campo',
    deletePolygon: 'Eliminar polígono',
    addPolygon: 'Agregar polígono',
    area: 'Superficie: ',
    areaField: 'Superficie del campo: ',
    hectare: 'ha',
    averageHectare: 'Promedio por hectárea: ',
    editingField: 'Edición del campo',
    editField: 'Editar campo',
    enterAddressYourField: 'Introduzca la dirección de su campo o haga clic en el mapa',
    enterRegion: 'Introduzca la región',
    enterDistrict: 'Introduzca el distrito',
    soilType: 'Tipo de suelo',
    nameField: 'Nombre del campo',
    enterNameField: 'Introduzca el nombre del campo',
    selectCategory: 'Seleccione la categoría',
    areaYourField: 'Superficie de su campo (ha)',
    autoArea: 'Superficie automática',
    maxSizeField: 'Tamaño máx. del campo',
    pairs: 'Barbecho',
    grade: 'Variedad',
    feedMix: 'Mezcla de forraje',
    confirmSowing: 'Confirmar siembra',
    sowing: 'Siembra',
    dateSowing: 'Fecha de siembra',
    volumeSowing: 'Volumen de siembra',
    noCropData: 'No hay datos de siembra',
    unitMeasure: 'Unidad de medida',
    volumeHarvest: 'Volumen de cosecha',
    cleaningDate: 'Fecha de recolección',
    collection: 'Recolección',
    amountCollected: 'Volumen recolectado',
    basicInformation: 'Información básica',
    stageGrowth: 'Etapa de crecimiento:',
    numberField: 'Campo №',
    shouldNotCross: 'Los campos no deben cruzarse',
    overlapNotAllowed: 'No se permite la autocruzación de campos',
  },
  cycle: {
    title: 'Ciclo',
    newCycle: 'Nuevo ciclo',
    addCycle: 'Agregar ciclo',
    removeCycle: 'Eliminar ciclo',
    currentCycle: 'Ciclo actual',
    changeCycle: 'Cambiar ciclo',
    editCycle: 'Editar ciclo',
    cropAndGrade: 'Cultivo y variedad',
    pairView: 'Tipo de barbecho',
    cleaning: 'Cosecha',
    confirmCleaning: 'Confirmar cosecha',
    volumeCleaning: 'Volumen de cosecha',
    scheduledCollection: 'Recolección programada:',
    harvest: 'Recolección: ',
    notPlanned: 'No planificado',
    informationMissing: 'No hay información sobre el ciclo actual',
    predecessor: 'Predecesor',
    noInformationPredecessor: 'No hay información sobre el predecesor',
  },
  region: {
    noDataGraphic: 'No hay datos para construir gráficos',
  },
  weather: {
    title: 'Pronóstico del tiempo',
    weather: 'Tiempo',
    humidity: 'Humedad',
    wind: 'Viento',
    temperature: 'Temperatura',
    precipitation: 'Precipitaciones',
    sumPrecipitations: 'Suma de precipitaciones',
    directionWind: 'Dirección del viento',
    dewTemperature: 'Temperatura del punto de rocío',
    atmosphericPressure: 'Presión atmosférica',
    airAndPrecipitation: 'Aire y precipitaciones',
    errorWeather: '¡Error al cargar el pronóstico del tiempo!',
    weatherForField: 'Pronóstico del tiempo para «Campo ',
    pressure: 'Presión',
    windGusts: 'Ráfagas de viento',
    short: {
      airTemperature: 'Temp. del aire',
      dewTemperature: 'Temp. punto de rocío',
      rainfall: 'Cant. de precip.',
      directionWind: 'Dir. del viento',
      windSpeed: 'Vel. del viento',
    },
  },
  analysis: {
    title: 'Análisis',
    addAnalysis: 'Agregar análisis',
    listAnalysis: 'Lista de análisis',
    analysisCollection: 'Recolección de análisis',
    emptyAnalysis: 'No hay análisis',
    gridFormation: 'Formación de la malla',
    secureNet: 'Fijar malla',
    routeMapping: 'Trazado de ruta',
    enterData: 'Entrada de datos',
    customer: 'OOO «KleverFarmer»',
    analysisField: 'Análisis del campo',
    saveData: 'Guardar datos',
    sectionNumberOne: 'Número de la primera parcela',
    downloadData: 'Cargar datos',
    startCollecting: 'Empezar la recolección',
    workDate: 'Fecha de trabajo',
    clearAnalysisTable: '¿Limpiar la tabla de datos de análisis?',
    collectingSamples: 'Cantidad de muestras a tomar: ',
    collectAnalyses: 'Recoger análisis',
    routeAnalysisCollector: 'Mostrar ruta del recolector de análisis',
    statusAnalysisCollection: 'Estado de la recolección de análisis',
    analysisTable: 'Tabla de análisis',
    dateAnalysis: 'Fecha de recolección de análisis:',
    analysisCollectionDateNotAvailable: '¡Falta la fecha de recolección de análisis!',
    fileGeneration: '¿Continuar generando el archivo?',
    displayed: 'Indicador mostrado',
    dateCollection: 'Fecha de recolección: ',
  },
  tableAssay: {
    basicAttributes: 'Atributos básicos',
    additionalAttributes: 'Atributos adicionales',
    numberEU: 'N.º EU p/p',
    numberSample: 'Número de muestra',
    average: 'Promedio',
  },
  laboratory: {
    title: 'Laboratorio',
    definitionForm: 'Formulario\nde definición',
    indicatorsAndMethodologies: 'Indicadores y metodologías agroquímicas',
    dischargeForm: 'Formulario de exportación/importación',
    testProtocol: 'PROTOCOLO DE ENSAYO №',
    from: 'de',
    nameCustomer: 'Nombre y dirección del cliente:',
    farmName: 'Nombre de la explotación:',
    sampleName: 'Nombre del objeto de estudio (muestra):',
    soil: 'suelo',
    selectLaboratory: 'Seleccione el laboratorio',
    transferSample: 'Toma y transporte de la muestra:',
    dateReceipt: 'Fecha de recepción del objeto (muestra):',
    testDate: 'Fecha de los ensayos:',
    settingsAttributes: 'Configuración de atributos para el archivo Excel',
    excelAttributes: 'Atributos del archivo Excel',
  },
  workLog: {
    title: 'Registro de trabajos',
    addWork: 'Agregar trabajo',
    date: 'Fecha',
    work: 'Trabajo',
    volume: 'Volumen',
    deleteWork: '¿Eliminar trabajo?',
    typeWorks: 'Tipo de trabajos',
    dateWork: 'Fecha de realización del trabajo',
    newWork: 'Trabajo nuevo',
  },
  satelliteMonitoring: {
    title: 'Monitoreo satelital',
    areaLimit: 'Se excedió el límite de superficie',
    connectSatellites: 'Conectar satélites',
    from: ' de ',
    dataProcessing: {
      first: 'Procesando datos satelitales.',
      second: 'Puede tardar algún tiempo',
    },
  },
  inspections: {
    title: 'Inspecciones',
    addTask: 'Agregar tarea de inspección',
    addResult: 'Agregar resultado de inspección',
    completedInspection: 'Inspección completada',
    changeInspection: 'Editar inspección',
    inspected: 'Inspección realizada',
    inspect: 'Realizar inspección',
    resultInspection: 'Resultado de la inspección',
    fieldInspection: 'Inspecciones del campo',
    planned: 'Programadas',
    completed: 'Completadas',
    scheduledInspection: 'Inspección programada',
    changeView: 'Editar inspección',
    reviewTask: 'Tarea para la inspección',
    inspectionAssignment: 'Asignación de inspección',
    executor: 'Ejecutor',
    priority: 'Prioridad',
    inspectionTime: 'Plazo de la inspección',
    inspectionDate: 'Fecha de la inspección',
    inspectionReport: 'Informe de inspección',
    reviewPhoto: 'Foto de la inspección',
    growthStage: 'Subetapas de crecimiento',
    currentStage: 'Etapa actual',
    stageNotDefined: 'Etapa no definida',
  },
  incidents: {
    title: 'Incidentes',
    addIncident: 'Agregar incidente',
    character: 'Carácter del incidente',
    description: 'Descripción del incidente',
    photo: 'Foto del incidente',
    delete: 'Eliminar incidente',
  },
  history: {
    title: 'Historial',
    historyFields: 'Historial del campo',
  },
  location: {
    title: 'Ubicación',
    locationSearch: 'Búsqueda de ubicación',
    address: 'Dirección',
    coordinates: 'Coordenadas',
    position: 'Posición actual',
    nearestTowns: 'Dirección del núcleo poblado más cercano',
    width: 'Latitud',
    length: 'Longitud',
    enterWidth: 'Introduzca latitud',
    enterLength: 'Introduzca longitud',
    yourLocation: 'Su ubicación',
    geolocationNotAvailable: '¡Geolocalización no disponible!',
  },
  groups: {
    withoutGroup: 'Sin grupo',
    newGroup: 'Nuevo grupo',
    nameNewGroup: 'Nombre del nuevo grupo',
    selectGroup: 'Seleccione un grupo',
    removeGroup: 'Eliminar grupo',
    massControl: 'Gestión masiva',
    removeFieldsGroup: '¿Eliminar campos del grupo?',
    createGroup: 'Crear grupo',
    moveGroup: 'Mover al grupo',
    removeFromGroup: 'Quitar del grupo',
    selectedFieldsMoveGroup: 'Tras crear, todos los campos seleccionados se moverán allí',
  },
  sorting: {
    filterAndSorting: 'Filtro y ordenación',
    byDate: 'Por fecha',
    alphabetically: 'Alfabéticamente',
    square: 'Por superficie',
    selectCulture: 'Seleccione cultivo',
    byIncrement: 'ascendente',
    byDecreasing: 'descendente',
    byAgroChemicalAnalysis: 'Por análisis agroquímico',
    collectionStatus: 'Estado de recolección',
    finished: 'Finalizado',
  },
  reportTypes: {
    reports: 'Informes',
    cropsReport: 'Siembras (informe)',
    cropsChart: 'Siembras (gráfico)',
    fieldsReport: 'Campos (informe)',
    fieldAnalysisReport: 'Informe de análisis de campos',
    addReport: 'Agregar informe',
    yourself: 'A mí',
    reportOffice: 'Informe de la Dirección',
    uship: 'USKhP',
    mship: 'MSKhP',
  },
  meteoStations: {
    title: 'Estaciones meteorológicas',
    newStation: 'Nueva estación',
    myStations: 'Mis estaciones',
    addStation: 'Agregar estación',
    stationCapacityAssessment: 'Evaluación de operatividad de estaciones',
    evaluationPeriod: 'Periodo de evaluación',
    graphic: 'Gráfico',
    editStation: 'Editar estación',
    editingStation: 'Edición de la estación',
    measured: 'Medido:',
    uvIndex: 'Índice UV',
    lighting: 'Iluminación',
    lux: 'Lux',
    sumTemperatures: 'Suma de temperaturas activas',
    sumTemperaturesPeriod: 'Suma de temperaturas activas (desde el inicio del periodo)',
    stationsNotLoaded: 'Error. ¡No se cargaron los datos de las estaciones!',
    days: 'días',
    sum: 'Suma, mm',
    precipitationAmount: 'Suma de precipitaciones',
    dailyPrecipitation: 'Precipitaciones diarias',
    oneDay: '1 día',
    withGustsUp: 'con ráfagas hasta',
    precipitation: 'Precipitaciones, mm',
    height: 'Altura',
    timeZone: 'Huso horario',
    model: 'Modelo de estación',
    surveyMethod: 'Método de sondeo',
    modules: 'Módulos de la estación',
    ip: 'IP/Host',
    port: 'Puerto',
    id: 'Identificador único de la estación',
    topic: 'Tópico para recibir datos',
    addSensor: 'Agregar sensor',
    measurementHorizonsTemperature: 'Horizontes de medición de temperatura del suelo',
    measurementHorizonsHumidity: 'Horizонtes de medición de humedad del suelo',
    observationArchive: 'Archivo de observaciones',
    collectedData: 'Datos acumulados',
    noDataAvailable: 'No hay datos para guardar',
    collected: 'Acumulados',
    dailyRates: 'Diarios',
    station: 'Acum.Estación_',
    indexAndIllumination: 'Índice UV e Iluminación',
    date: 'Fecha/Hora',
    stationArchive: 'Arch.Estación',
    requests: 'Solicitudes',
  },
  areas: {
    title: 'Distritos',
    area: 'Distrito',
    nameArea: 'Nombre del distrito',
    myAreas: 'Mis distritos',
    localities: 'Localidades',
    region: 'Región',
    districtAdministration: 'Administración del distrito',
    regionalAdministration: 'Administración regional',
    couldNotDetermine: '¡No se pudo determinar la región! ¡Seleccione manualmente!',
  },
  directories: {
    title: 'Directorios',
    workManual: 'Directorio de trabajos',
    machineryAndEquipment: 'Máquinas y agregados',
    typeWork: 'Tipo de trabajo',
    measurementUnit: 'Unidad de medida',
    attributes: 'Atributos',
  },
  attributes: {
    attributeRemoval: 'Eliminación de atributos',
    wantRemoveAttributes: '¿Desea eliminar todos los atributos?',
    jobAttributes: 'Atributos de trabajos',
    typeWork: 'Tipo de trabajos',
    title: 'Título',
    enterTitle: 'Introduzca el título',
    listItemHeader: 'Encabezado del elemento de la lista',
    addListItem: 'Agregar elemento de lista',
    addAttribute: 'Agregar atributo',
    settingAttributes: 'Configuración de atributos',
  },
  machineryAndEquipment: {
    name: 'Nombre',
    number: 'Matrícula',
    type: 'Tipo de maquinaria',
  },
  agroChemicalExamination: {
    title: 'Examen agroquímico',
  },
  act: {
    actNumber: 'Acta № ',
    removalAct: 'Eliminación del acta',
    wantDeleteAct: '¿Desea eliminar el acta?',
    selectionAct: 'Acta de muestreo',
    annexAct: 'Anexo al acta de muestreo',
    sampleTags: 'Etiquetas de muestras',
    next: 'Siguiente',
    sendingLaboratory: 'Envío al laboratorio',
    sendLaboratory: 'Enviar al laboratorio',
    documents: 'Documentos:',
    listDocuments: 'Lista de documentos',
    readyDocuments: 'Documentos preparados',
    downloadReadyDocuments: 'Descargue los documentos preparados y envíelos al laboratorio',
    dataSelectionAct: 'Rellene los datos para formar el acta de muestreo',
    testData: 'Datos del ensayo',
    actSelectionNumber: 'Número del acta de muestreo',
    testDate: 'Fecha del ensayo',
    pickerName: 'Nombre del muestreador',
    namePresent: 'Nombre del presente',
    nameCustomer: 'Nombre del cliente',
    testLayer: 'Capa de suelo investigada, cm',
    sampleSendingData: 'Rellene los datos para enviar muestras al laboratorio',
  },
  map: {
    title: 'Mapa',
    maps: 'Mapas',
    yandexMaps: 'Mapas Yandex',
    googleMaps: 'Mapas Google',
    selectCard: 'Seleccione el tipo de mapa',
    regionalOffice: 'Rosreestr',
    undoChanges: 'Deshacer cambios',
    gridType: 'Tipo de malla',
    gridArea: 'Superficie de la malla: ',
    tiltAngle: 'Ángulo de inclinación: ',
    scale: 'Escala: ',
    changePoint: 'Cambiar la ubicación de los puntos',
    combinePlots: 'Unir parcelas',
    changeNumberPlot: 'Cambiar número de la parcela',
    numberPlot: 'Número de la parcela elemental',
    removePlot: 'Eliminar parcela',
    cancelStep: 'Deshacer paso',
    clearRoute: 'Limpiar de ruta',
    positioning: 'Determinación de ubicación',
    cancelPosition: 'Cancelar posición',
    startingNew: 'Empezar nuevo',
    fixedPosition: 'Fijar posición',
    saveMap: 'Guardar mapa para imprimir',
    addDot: 'Agregar punto',
    pointChosen: '¡Uno de los puntos de la línea ya fue elegido!',
    simplifyContour: 'Simplificar contorno',
    accuracy: 'Precisión',
    plots: 'parcela(s)',
    route: 'Ruta',
    matrix: 'Matriz',
    curtain: 'Cortina',
    notifications: {
      deviceNotNavigation: '¡Error! El dispositivo no tiene navegación',
      waitLocation: '¡Espere la determinación de la ubicación!',
      collectionAnalysis: '¡Se realizó recolección de análisis en el campo!',
      alreadyCollectionAnalysis: '¡Ya hubo recolección de análisis en el polígono!',
      polygonNotFound: '¡No se encontró polígono en la posición actual!',
      dotInField: '¡Error! Coloque el punto dentro del campo',
      locationOnMap: '¡Coloque un lugar en el mapa para la inspección!',
      placeOnMap: '¡Coloque un lugar en el mapa!',
    },
  },
  baseValidation: {
    requiredField: 'Campo obligatorio',
    incorrectEmail: 'Introduzca un E-mail válido',
    passwordsDontMatch: 'Las contraseñas no coinciden',
    minCharacters: {
      start: 'Mínimo',
      end: 'caracteres',
    },
    maxCharacters: {
      start: 'Máximo',
      end: 'caracteres',
    },
    minValue: 'Valor mínimo ',
    maxValue: 'Valor máximo ',
    numberValue: 'El valor debe ser un número',
  },
  satellite: {
    title: 'Satélite',
    imageDate: 'Fecha de la imagen',
    cloud: 'Nubosidad',
    representation: 'Representación',
    applyAllFields: 'Aplicar a todos los campos',
    layer: 'Capa',
    fieldChronology: 'Cronología del campo',
  },
  agroChemicalAnalysis: {
    title: 'Análisis agroquímico',
    fieldAverage: 'Promedio del campo',
    indicator: 'Indicador',
    interpolation: 'Interpolación',
    noAnalysis: 'Sin análisis',
    notStarted: 'No iniciado',
    inProcess: 'En proceso',
    finished: 'Finalizado',
    completed: 'Completado',
  },
  cabinetFarms: {
    title: 'Panel de la explotación',
    nameFarms: 'Nombres de las explotaciones',
    organizationProfile: 'Perfil de la organización',
  },
  users: {
    title: 'Usuarios',
    user: 'Usuario',
    newUser: 'Nuevo usuario',
    superManager: 'Superadministrador',
    inviteUsers: 'Invitar usuario',
    name: 'Nombre',
    removalUser: 'Eliminación de usuario',
    wantDeleteUser: '¿Desea eliminar al usuario?',
    roles: 'Roles',
    notChangeRoles: 'No puede cambiar sus propios roles',
    invitationSent: 'Invitación enviada',
  },
  managementReport: {
    title: 'Informe de la explotación',
    nameFarm: 'Nombre de la explotación',
    culture: 'Cultivo',
    area: 'Superficie, ha',
  },
  fieldAnalysisReport: {
    yearsAnalysis: 'Año de análisis',
    requestReport: 'Solicitar informe',
    moreInformation: 'Información adicional',
    typesDryLand: 'Tipos de tierras agrícolas',
    data: {
      title: 'Datos a',
      yearMissing: 'año inexistentes!',
    },
    intro: 'Introducción',
    conclusion: 'Conclusión',
    file: {
      start: 'Informe de análisis de campos por ',
      end: ' año.zip',
    },
  },
  tableStatuses: {
    veryLow: 'Muy bajo',
    low: 'Bajo',
    normal: 'Normal',
    average: 'Medio',
    high: 'Alto',
    veryHigh: 'Muy alto',
  },
  spectrogramIndicators: {
    veryLow: 'Muy bajo',
    low: 'Bajo',
    average: 'Medio',
    high: 'Elevado',
    veryHigh: 'Alto',
  },
  cropDistribution: {
    title: 'Distribución de siembras por cultivos y variedades',
    withoutGrade: 'Sin variedad',
    noDataForChart: 'No hay datos para construir el gráfico',
  },
  tasks: {
    title: 'Tareas',
    tasksAndReports: 'Tareas e informes',
  },
  datePicker: {
    incorrectDate: 'Fecha introducida incorrectamente',
    sequenceBroken: 'La secuencia de días está rota',
    rangeDate: 'Rango de fechas',
  },
  layerTypes: {
    notShow: 'No mostrar',
    naturalColor: 'Color natural',
  },
  presentationTypes: {
    index: 'Índice',
    homogeneity: 'Homogeneidad',
    dynamics: 'Dinámica',
  },
  dangerousPhenomena: {
    title: 'Fenómenos peligrosos',
    check: 'Comprobar',
    date: 'Fecha',
    type: 'Tipo',
    dataMissing: 'No hay datos',
    selectPeriodAndType: 'Seleccione periodo y tipo de fenómenos peligrosos',
  },
  indicators: {
    n: 'Nitrógeno (N)',
    p: 'Fósforo (P)',
    k: 'Potasio (K)',
    s: 'Azufre (S)',
    ph: 'pH',
    humus: 'Humus',
    salinization: 'Salinización',
    ca: 'Calcio (Ca)',
    mg: 'Magnesio (Mg)',
    fe: 'Hierro (Fe)',
    mn: 'Manganeso (Mn)',
    zn: 'Zinc (Zn)',
    cu: 'Cobre (Cu)',
    b: 'Boro (B)',
    mo: 'Molibdeno (Mo)',
    na: 'Sodio (Na)',
    cl: 'Cloro (Cl)',
    co: 'Cobalto (Co)',
    soilCompaction: 'Compactación del suelo',
    salinizationType: 'Tipo de salinización',
  },
  optionsIndicators: {
    'Стандартный метод': 'Método estándar',
    'по Тюрину и Коноваловой': 'según Tyurin y Konovalova',
    'по Корнфилду': 'según Kornfield',
    'по Кравкову': 'según Kravkov',
    'по Мачигину': 'según Machiguin',
    'по Кирсанову': 'según Kirsanov',
    'по Чирикову': 'según Chirikov',
    'по Эгнеру Римму': 'según Egner Rimm',
    'по Маслову': 'según Maslov',
    Сульфатное: 'Sulfatada',
    Хлоридное: 'Clorada',
    'Сульфатно-хлоридное': 'Sulfatada-clorada',
    'Хлоридно-сульфатное': 'Clorada-sulfatada',
    'Содово-хлоридный': 'Sódico-clorado',
    'Содово-сульфатный': 'Sódico-sulfatado',
    'Хлоридно-содовый': 'Clorado-sódico',
    'Сульфатно-содовый': 'Sulfatado-sódico',
    'Сульфатно-хлоридный гидрокарбонатный': 'Sulfatado-clorhídrico bicarbonatado',
    Карбонатное: 'Carbonatada',
  },
  suffixes: {
    massFraction: 'мг/кг',
    density: 'г/см³',
    pressure: 'кг/см2',
    percent: '%',
    degree: '°C',
    millimetre: 'мм',
    metersPerSecond: 'm/s',
    degreeAngle: '°',
    atmosphericPressure: 'mm Hg',
    precipitation: 'мм/h',
    centimeter: 'см',
  },
  labelsAttributeType: {
    string: 'Texto',
    text: 'Texto multilínea',
    flag: 'Bandera',
    list: 'Lista',
  },
  machineryTypeLabel: {
    selfPropelled: 'Autopropulsado',
    trailer: 'Remolque',
  },
  fieldsCategories: {
    cropland: 'Tierra de cultivo',
    hayfield: 'Pradera de heno',
    permanentCrops: 'Cultivos perennes',
    pasture: 'Pastoreo',
    fallowLand: 'Barbecho',
  },
  saveInImage: {
    inJpeg: 'Guardar en JPEG',
    inPng: 'Guardar en PNG',
    inSvg: 'Guardar en SVG',
  },
  textUnits: {
    tn: 't',
    cwt: 'qq',
    kg: 'kg',
    num: 'ud',
    su: 'cwt',
    suha: 'unid. siembra',
    tnha: 't/ha',
    cwtha: 'qq/ha',
    kgha: 'kg/ha',
    numha: 'ud/ha',
  },
  textFallows: {
    clear: 'Limpio',
    occupied: 'Ocupado',
    half: 'Medio barbecho',
    sideral: 'Abono verde',
  },
  assayType: {
    gost: 'GOST',
    bionic: 'Biónico',
  },
  roteLabel: {
    auto: 'Automático',
    hand: 'Manual',
  },
  errorsPolygon: {
    selectPointPolygon: '¡Seleccione un polígono que contenga un punto!',
    selectActivePolygon: '¡Seleccione un polígono activo!',
    notMatchNumber: '¡Error de importación! La cantidad de polígonos importados no coincide con la actual.',
    checkPolygonsMatch: '¡Error de importación! Verifique la correspondencia de polígonos.',
    errorSelectRoute: '¡Error! Seleccione una ruta.',
    errorRequiredFields: '¡Error! Rellene los campos obligatorios.',
    typeImportError: '¡Error de importación de tipos! Verifique el tipo',
    initializationError: '¡Error de inicialización!',
  },
  seriesTypes: {
    calm: 'Calma',
    lightWind: 'Viento ligero',
    lightBreeze: 'Brisa ligera',
    weakWind: 'Viento débil',
    moderateWind: 'Viento moderado',
    freshBreeze: 'Brisa fresca',
    nearStorm: 'Cercano a tormenta',
    storm: 'Tormenta',
    strongWind: 'Viento fuerte',
    fierceStorm: 'Tormenta severa',
    hurricane: 'Huracán',
  },
  highcharts: {
    loading: 'Cargando...',
    months: {
      January: 'Enero',
      February: 'Febrero',
      March: 'Marzo',
      April: 'Abril',
      May: 'Mayo',
      June: 'Junio',
      July: 'Julio',
      August: 'Agosto',
      September: 'Septiembre',
      October: 'Octubre',
      November: 'Noviembre',
      December: 'Diciembre',
    },
    weekdays: {
      Sunday: 'Domingo',
      Monday: 'Lunes',
      Tuesday: 'Martes',
      Wednesday: 'Miércoles',
      Thursday: 'Jueves',
      Friday: 'Viernes',
      Saturday: 'Sábado',
    },
    shortMonths: {
      January: 'Ene',
      February: 'Feb',
      March: 'Mar',
      April: 'Abr',
      May: 'May',
      June: 'Jun',
      July: 'Jul',
      August: 'Ago',
      September: 'Sep',
      October: 'Oct',
      November: 'Nov',
      December: 'Dic',
    },
    rangeSelectorFrom: 'De',
    rangeSelectorTo: 'A',
    rangeSelectorZoom: 'Periodo',
    downloadPNG: 'Descargar PNG',
    downloadJPEG: 'Descargar JPEG',
    downloadPDF: 'Descargar PDF',
    downloadSVG: 'Descargar SVG',
    printChart: 'Imprimir gráfico',
    resetZoom: 'Restablecer zoom',
    viewFullscreen: 'Pantalla completa',
    exitFullscreen: 'Modo normal',
    errorSaveFile: 'Error al guardar el archivo',
  },
  timezone: {
    utc2: 'UTC+2, Kaliningrado',
    utc3: 'UTC+3, Moscú',
    utc4: 'UTC+4, Astracán',
    utc5: 'UTC+5, Ekaterimburgo',
    utc6: 'UTC+6, Omsk',
    utc7: 'UTC+7, Krasnoyarsk',
    utc8: 'UTC+8, Irkutsk',
    utc9: 'UTC+9, Yakutsk',
    utc10: 'UTC+10, Vladivostok',
    utc11: 'UTC+11, Magadán',
  },
  dangerousPhenomenaTypes: {
    dryWind: 'Viento seco',
    atmosphericDrought: 'Sequía atmosférica',
    frost: 'Heladas',
    heavyDownpour: 'Lluvia torrencial',
    heavyRain: 'Lluvia intensa',
  },
  incidentTypes: {
    disease: 'Enfermedad',
    pest: 'Plagas y parásitos',
    technological: 'Error tecnológico',
    flooding: 'Inundación',
    lodging: 'Acame',
    weed: 'Malezas',
    other: 'Otro',
  },
  router: {
    error403: 'Error 403',
    main: 'KleverFarmer',
    districts: 'Distritos',
    organizations: 'Organizaciones',
    fields: 'Campos y siembras',
    agroSurvey: 'Examen agroquímico',
    worksManual: 'Directorio de trabajos',
    machines: 'Máquinas y agregados',
    constructionLog: 'Registro de trabajos',
    fieldHistory: 'Historial del campo',
    satellite: 'Datos satelitales',
    scouting: 'Inspecciones de campos',
    meteos: 'Estaciones meteorológicas',
    stationPerformance: 'Evaluación de operatividad de estaciones',
    organizationProfile: 'Perfil de la organización',
    cropStructure: 'Estructura de siembras',
    speciesTable: 'Estructura de siembras / salida tabular',
    fieldsTable: 'Lista de campos / salida tabular',
    fieldsAnalysisReport: 'Informe de análisis de campos',
    login: 'Inicio de sesión',
    restorePassword: 'Restablecimiento de contraseña',
    invite: 'Invitación',
    error404: 'Error 404',
  },
  httpErrors: {
    noAccess: 'No hay acceso al servidor.',
    accessDenied: 'Error 403: Acceso denegado.',
    error404: 'Error 404',
    fieldFillingError: '¡Error al completar los campos!',
    manyRequests: 'Error 429: Demasiadas solicitudes.',
    unexpectedErrorOccurred: '¡Se produjo un error inesperado! ¡Contacte al administrador!',
    defaultError: 'Se produjo un error inesperado.',
  },
};
